<template>
  <tr v-if="editMode">
    <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6" :class="{'has-error': isInvalid('name')}">
      <input type="text" class="input-field " v-model="data.name">
      <div v-if="isInvalid('name')" class="error-message mt-1">{{ errorMessage('name') }}</div>
    </td>
    <td class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
      <button class="btn-primary text-sm  mr-2" @click="updateReason">Save</button>
      <button class="btn-secondary mr-2 text-sm" @click="cancel">Cancel</button>
      <div v-if="isInvalid('name')" class="error-message mt-1">&nbsp;</div>
    </td>
  </tr>
  <tr v-else>
    <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">{{ reason.name }}</td>
    <td class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
      <button class="btn-secondary mr-2 text-sm" @click="editMode = true">Edit</button>
      <button class="btn-primary bg-red-500 hover:bg-red-500 text-white text-sm" @click="confirmDelete">Delete</button>
    </td>
  </tr>
</template>

<script>
import _ from "lodash";
import helpers from "../../helper";
import serverValidationErrorsMixin from "../mixins/serverValidationErrorsMixin";

export default {
  name: "AgencyDeadReasonListItem",

  mixins: [serverValidationErrorsMixin],

  props: {
    agencyId: {
      type: Number,
      required: true,
    },
    reason: {
      type: Object,
      required: true,
    }
  },

  emits: ['reason-updated', 'reason-deleted'],

  data() {
    return {
      data: _.cloneDeep(this.reason),
      editMode: false,
    }
  },

  methods: {
    updateReason() {
      this.loading = false;
      // AgencyDeadReasonController@update
      axios
        .put(`/agencies/${this.agencyId}/dead-reasons/${this.data.id}`, {
          name: this.data.name
        })
        .then((response) => {
          this.$emit('reason-updated', {reason: response.data});
          this.data = response.data;
          this.editMode = false;
        })
        .catch(error => {
          if (error.response && error.response.data && error.response.status === 422) {
            this.errors = error.response.data.errors;
            this.$nextTick(() => {
              helpers.scrollToClass('has-error');
            })
          } else {
            Swal.fire({
              text: 'Unknown error occurred, please try again.',
              icon: 'error'
            })
          }
          console.log("AgencyDeadReasonListItem - handleErroredSubmission", error);
        })
        .finally(() => {
          this.loading = false;
        })
    },

    confirmDelete() {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You will not be able to undo this.',
        icon: 'warning',
        confirmButtonText: "Yes, I'm sure.",
        showCancelButton: true,
        confirmButtonColor: '#B91C1C',
        cancelButtonColor: '#899CC1'
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteReason();
        }
      })
    },

    deleteReason() {
      this.loading = true;
      // AgencyDeadReasonController@destroy
      axios
        .delete(`/agencies/${this.agencyId}/dead-reasons/${this.data.id}`)
        .then((response) => {
          this.$emit('reason-deleted');
        })
        .catch((error) => {
          Swal.fire({
            text: 'Unknown error occurred, please try again.',
            icon: 'error'
          });
        })
        .finally(() => {
          this.loading = false;
        })
    },

    cancel() {
      this.editMode = false;
    },
  },
}
</script>

<style scoped>

</style>